module.exports = __webpack_public_path__ + "img/swiper-2.3615565.png";